import { parseDate } from './utils'

export default class Sms {
	static fromJSON(json) {
		return new Sms(
			json.id,
			json.processId,
			json.number,
			json.message,
			json.confirmed,
			json.sendId,
			json.creationUser,
			json.creationDate,
			json.resultText
		)
	}

	constructor(
		id,
		processId,
		number,
		message,
		confirmed,
		sendId,
		creationUser,
		creationDate,
		resultText
	) {
		this.id = id
		this.processId = processId
		this.number = number
		this.message = message
		this.confirmed = confirmed
		this.sendId = sendId
		this.creationUser = creationUser
		this.creationDate = creationDate ? parseDate(creationDate) : {}
		this.resultText = resultText
	}
}
